import { SET_RWG_TOKEN_SOURCE_TYPE } from 'actions';

export const setRwgTokenSourceType = (rwgToken: string) => {
  return { rwgToken, type: SET_RWG_TOKEN_SOURCE_TYPE };
};
